import * as React from 'react';
import customSolarIconWrapper from '../../../custom-icons';

// Placed on the shared 240x240 doodle frame: stack a body, eyes, mouth and accessory to compose a doodle
const DoodleAccessoryStars = customSolarIconWrapper(<g transform="translate(168 30)">
	<path d="M24 6L28.5 19.5L42 24L28.5 28.5L24 42L19.5 28.5L6 24L19.5 19.5L24 6Z" fill="#202020" />
	<path d="M47 34L49.6 41.4L57 44L49.6 46.6L47 54L44.4 46.6L37 44L44.4 41.4L47 34Z" fill="#202020" />
</g>, { viewBox: '0 0 240 240' });

export default DoodleAccessoryStars;
